import script from "./NewResourceStatistics.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewResourceStatistics.vue?vue&type=script&setup=true&lang=ts"

import "./NewResourceStatistics.vue?vue&type=style&index=0&id=b3b923ae&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/运营辅助平台正式前端/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3b923ae"]])

export default __exports__